import React from 'react'
import { useAccountLock } from '../../../hooks/useAccountLock'
import { AccountLocked } from '../AccountLocked/AccountLocked'

interface AccountLockGuardProps {
  children: React.ReactNode
}

export const AccountLockGuard: React.FC<AccountLockGuardProps> = ({
  children,
}) => {
  const { isAccountLocked, loading } = useAccountLock()

  // While checking lock status, show loading
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          fontSize: '18px',
        }}>
        Checking account status...
      </div>
    )
  }

  // If account is locked, show the lock screen
  if (isAccountLocked) {
    return <AccountLocked />
  }

  // If account is not locked, render children normally
  return <>{children}</>
}
